import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { hasGroupingProducts } from '@yme/selectors/helpers';
import { getProductDetails, getProductDetailsVariantsWithGroupingProducts, getProductVariantsByColorWithGroupingProducts, } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getProductFilterOptions, PRODUCT_CARD_SECTION_ID } from '../ProductCard';
import { getSpecificationDescription } from './helpers';
import { RowStyled, ColStyled, FlexWrapperStyled, ChangeConfigurationButtonStyled, SelectedModelWrapperStyled, } from './styled';
export function SectionHOC(props) {
    const { headerLeftSide, headerRightSide, bottomSection, children, isRightToLeft, bgColor } = props;
    const { t } = useTranslation();
    const { data } = useSelector(getProductDetails);
    const productName = data?.name ?? '';
    const productFilterOptions = useSelector(getProductFilterOptions);
    const allVariantsWithGroupingProducts = useSelector(getProductDetailsVariantsWithGroupingProducts);
    const productVariantsByColor = useSelector(getProductVariantsByColorWithGroupingProducts);
    const productSpecificationDescription = useMemo(() => getSpecificationDescription({
        productFilterOptions,
        productName,
        productVariantsByColor,
        allVariantsWithGroupingProducts,
        t,
    }), [productFilterOptions, productName, productVariantsByColor, allVariantsWithGroupingProducts, t]);
    const isProductWithGroupingProducts = useMemo(() => hasGroupingProducts(data), [data]);
    const onClick = useCallback(() => {
        const cardPanel = document.getElementById(PRODUCT_CARD_SECTION_ID);
        if (cardPanel) {
            cardPanel.scrollIntoView({
                behavior: 'smooth',
            });
        }
    }, []);
    return (React.createElement(Container, null,
        React.createElement(RowStyled, null,
            React.createElement(ColStyled, null,
                React.createElement(FlexWrapperStyled, { bg: bgColor, isRightToLeft: isRightToLeft },
                    React.createElement(Container, { expanded: true, maxWidth: "100%" },
                        React.createElement(Row, { mb: isProductWithGroupingProducts ? '4px' : '16px', mdMb: isProductWithGroupingProducts ? '4px' : '24px', lgMb: isProductWithGroupingProducts ? '4px' : '32px' },
                            React.createElement(Col, { md: 4, lg: 6, justifyContent: "flex-start" }, headerLeftSide),
                            headerRightSide && (React.createElement(Col, { md: 4, lg: 6, justifyContent: "flex-end", display: "flex" }, headerRightSide))),
                        isProductWithGroupingProducts && (React.createElement(Row, { mb: "16px", mdMb: "24px", lgMb: "32px" },
                            React.createElement(Col, null,
                                React.createElement(FlexWrapper, { flexWrap: "wrap", gap: "4px" },
                                    React.createElement(SelectedModelWrapperStyled, null,
                                        React.createElement(RegularTextLevel3, { as: 'span' }, `${t('specifications_selectedModel_label')} `),
                                        React.createElement(RegularTextLevel3, { as: 'span' }, productSpecificationDescription)),
                                    React.createElement(ChangeConfigurationButtonStyled, { onClick: onClick }, t('specifications_changeConfiguration_label')))))),
                        React.createElement(Row, null,
                            React.createElement(Col, null, children)),
                        bottomSection && (React.createElement(Row, { mt: "24px" },
                            React.createElement(Col, null,
                                React.createElement(FlexWrapper, { alignItems: "center", justifyContent: "center" }, bottomSection))))))))));
}
SectionHOC.displayName = 'SectionHOC_Component';
